package com.eladfinish.bible.contest.common.usecases

import com.eladfinish.bible.contest.constants.StringConstants.Regex.NIKUD_CHARS
import com.eladfinish.bible.contest.extensions.replaceRegex

class RemoveNikudUseCase {

    operator fun invoke(pasuk: String): String =
        pasuk
            .replaceRegex(
                regex = NIKUD_CHARS,
                replacement = ""
            )

}
